export default "__VITE_ASSET__d8dd7a0f__"